/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PageContentMessage } from "../../../messages";

const MODULE_NAME =
  "services.PortfolioUnderReviewPageService.machines.GetPageContent.state.formatLeafNodes";
const log = LoggerModule?.getInstance();

export const formatLeafNodes = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      if (msg?.leafNodes?.data && msg?.collection?.collectionList) {
        for (const coll of msg?.leafNodes?.data) {
          msg.collection?.collectionList?.push({
            id: coll?.id,
            title: coll?.name,
            description: coll?.desc,
            image: coll?.primaryAsset?.src,
            catalogueType: "leaf",
            serialNo: `Rare #/${coll?.id?.split("_")?.pop()}`,
            price: [
              {
                type: "crypto",
                amount: coll?.price?.amount,
                currency: coll?.price?.currency,
                sale: {
                  salePrice: null,
                  saleEndDate: null,
                },
                symbol: "S",
              },
            ],
            type: coll?.type,
          });
        }
        msg.collection.totalCount = msg.leafNodes.totalCount;
        msg.collection.totalPages = msg.leafNodes.totalPages;
        msg.collection.currentPage = msg.leafNodes.currentPage;
        console.log("format Leave node ->", msg.collection);
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatLeafNodes", err);
      return reject(err?.message);
    }
  });
};
